import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { GLOBAL } from 'app/@common/constants'

export default function SelectCurrency({...props}) {

    const myProps = {
        urlAjax: GLOBAL.CURRENCY,
        placeholder: i18n.t('common:filters.currency'), icon: {icon: 'money-bill-wave-alt'},
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}